import useSavedViewCleaner from '@/composables/saved-views/saved-view-cleaner';
import { computed, ref } from 'vue';
import { copy } from 'shared/lib/copy';
import { useI18n } from 'vue-i18n';

export default function useDefaultView(defaultView, defaultProps, viewApplication, propertyOption, planning, user, loggedInUser, loggedInUserAccount, gridPageTile, repo) {
  const { clearView } = useSavedViewCleaner();

  const { t } = useI18n();
  const buildDefaultView = (view) => clearView({
    view: {
      uid: 0,
      goalSort: [],
      ...copy(view),
      isTemp: true,
      creator: { uid: loggedInUser.value.uid },
      account: { uid: loggedInUserAccount.value.uid },
      viewApplication,
      propertyOption,
      planning,
      user,
      gridPageTile,
    },
    props: defaultProps.value,
  });

  const defaultViewCopy = buildDefaultView(defaultView);
  const defaultViewLocal = ref(copy(defaultViewCopy));

  const views = computed(() => {
    if (repo.views.value.length === 0) {
      return [defaultViewLocal.value];
    }

    return repo.views.value;
  });

  const resetView = (id) => {
    const view = views.value.find((v) => v.uid === id);
    if (view === undefined) {
      throw new Error(`view not found with id: ${id}`);
    }

    defaultViewLocal.value = copy(defaultViewCopy);
    return views.value.find((v) => v.uid === id);
  };

  const createView = (view) => {
    const viewsToCreate = [];
    const isDefaultView = [];

    if (views.value.length === 1) {
      viewsToCreate.push({
        ...defaultViewCopy,
        title: t('list.default'),
        isPublic: view.isPublic,
      });

      isDefaultView.push(true);
    }

    viewsToCreate.push(buildDefaultView(view));
    isDefaultView.push(false);

    return repo.createViews(viewsToCreate, isDefaultView).then(() => views.value.find((v) => v.title === view.title));
  };

  const updateView = (view) => {
    if (view.isTemp) {
      defaultViewLocal.value = view;
      return view;
    }

    return repo.updateView(view);
  };

  return {
    loadingCreateView: repo.loadingCreateView,
    createView,

    loadingUpdateView: repo.loadingUpdateView,
    updateView,

    loadingUpdateMetaData: repo.loadingUpdateMetaData,
    updateMetaData: repo.updateMetaData,

    loadingDeleteView: repo.loadingDeleteView,
    deleteView: repo.deleteView,

    setParams: repo.setParams,

    resetView,

    hasUnsavedChanges: repo.hasUnsavedChanges,

    views,
  };
}
